import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { CalendarAngularDateFormatter, DateFormatterParams } from 'angular-calendar';

/**
 * Formatador de datas do calendário com relógio de 24 horas em português.
 *
 * O formatador padrão do angular-calendar (`CalendarAngularDateFormatter`)
 * pede `'h a'` na régua de horas — 12 horas com am/pm — INDEPENDENTE do locale.
 * Em pt-BR isso produz "8 AM", que não é a convenção do idioma.
 *
 * Só a régua de horas (semana e dia) é sobrescrita; todo o resto continua
 * exatamente como o padrão da lib.
 */
@Injectable()
export class JemsCalendarDateFormatter extends CalendarAngularDateFormatter {
  /** Régua de horas da visão de semana. */
  weekViewHour({ date, locale }: DateFormatterParams): string {
    return usesTwentyFourHourClock(locale)
      ? formatDate(date, 'HH:mm', locale)
      : super.weekViewHour({ date, locale });
  }

  /** Régua de horas da visão de dia. */
  dayViewHour({ date, locale }: DateFormatterParams): string {
    return usesTwentyFourHourClock(locale)
      ? formatDate(date, 'HH:mm', locale)
      : super.dayViewHour({ date, locale });
  }
}

/** Cobre `pt`, `pt-BR`, `pt-PT` — o app hoje usa `pt-BR`. */
function usesTwentyFourHourClock(locale: string): boolean {
  return (locale || '').toLowerCase().indexOf('pt') === 0;
}
